<script>
import MovementsEventsTable from '@modules/consolidator/components/movements-events-table/movements-events-table.vue'

export default {
  name: 'AssetTabEventos',
  components: { MovementsEventsTable },
  props: {
    asset: {
      type: Object,
      required: true,
    },
    proventos: {
      type: Array,
      default: () => [],
    },
    splits: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isinWarning() {
      return (this.asset.warnings && this.asset.warnings.isin) || null
    },
    eventItems() {
      return [...this.proventos, ...this.splits]
    },
  },
}
</script>

<template>
  <div>
    <BaseAlert v-if="isinWarning" icon="warning" icon-color="warning" class="my-2">
      <span class="text-normal">
        {{ isinWarning }}
      </span>
    </BaseAlert>
    <MovementsEventsTable
      mode="events"
      hide-title
      :asset="asset"
      :proventos="proventos"
      :splits="splits"
      :loading="loading"
      :event-items="eventItems"
    />
  </div>
</template>
